import React, { createContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

export const UserContext = createContext(null);

const UserContextProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [topics, setTopics] = useState({});

    useEffect(() => {
        fetch('/actions/auth/api/fetch-fields')
            .then((response) => response.json())
            .then(({ interests }) => setTopics(interests));

        fetch('/actions/auth/api/fetch-user-info')
            .then((response) => response.json())
            .then((user) => setUser(user));
    }, [setTopics, setUser]);

    return <UserContext.Provider value={{ user, topics }}>{children}</UserContext.Provider>;
};

UserContextProvider.propTypes = {
    children: PropTypes.element,
};

export default UserContextProvider;
